export const APP_FILE_BEFORE_CREATE = "/task-list";
export const APP_FILE_OLD_BUSINESS_TRACKER = "/old-task-list";
export const APP_FILE_VIEW_TASK_DETAILS = "/task-view";
// export const APP_FILE_CREATE_TASKS = "/tasks";
export const APP_FILE_INSURANCE_REPORTS_TAB = "/insurance-reports";
 export const APP_FILE_OLD_INSURANCE_REPORTS_LIST = "/old-insurance-reports";
export const APP_FILE_ORDER_INSURANCE_REPORT = "/insurance-reports/order-insurance-report";
export const APP_FILE_NO_POLICY_INSURANCE_REPORT = "/insurance-reports/no-policy/:licenseNumber/:incrementalNumber";
 export const APP_FILE_TASK_BOARD = "/taskboard";
 export const APP_FILE_TASK_CALENDER = "/task-calendar";
 export const APP_FILE_RENEWAL_LIST= "/renewals";
 export const APP_FILE_TASK_BINDER_LIST= "/binders";
 export const APP_FILE_BINDER_LIST= "/all-binders";
 export const APP_FILE_TASK_MARKETINGS_LIST= "/marketing";
 export const APP_FILE_TASK_ADD_MARKETING= "/manage-marketing";
 export const APP_FILE_REQUESTED_USER_NAME = "/requested-user-name";
export const APP_FILE_CERTIFICATE_OF_INSURANCE = "/certificate-of-insurance";